import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Document360_OperationService } from './Document360.operation.service';
import { Usersnap_OperationService } from './Usersnap.operation.service';
import { Utilities_OperationService } from './Utilities.operation.service';
import { Addresses_OperationService } from './Addresses.operation.service';
import { Discussions_OperationService } from './Discussions.operation.service';
import { DockAppointments_OperationService } from './DockAppointments.operation.service';
import { Owners_OperationService } from './Owners.operation.service';
import { Instructions_OperationService } from './Instructions.operation.service';
import { Materials_OperationService } from './Materials.operation.service';
import { Carriers_OperationService } from './Carriers.operation.service';
import { Locations_OperationService } from './Locations.operation.service';
import { PurchaseOrders_OperationService } from './PurchaseOrders.operation.service';
import { Invoices_OperationService } from './Invoices.operation.service';
import { Notifications_OperationService } from './Notifications.operation.service';
import { SalesOrders_OperationService } from './SalesOrders.operation.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
    this.Document360 = this.injector.get(Document360_OperationService);
    this.Usersnap = this.injector.get(Usersnap_OperationService);
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.Addresses = this.injector.get(Addresses_OperationService);
    this.Discussions = this.injector.get(Discussions_OperationService);
    this.DockAppointments = this.injector.get(DockAppointments_OperationService);
    this.Owners = this.injector.get(Owners_OperationService);
    this.Instructions = this.injector.get(Instructions_OperationService);
    this.Materials = this.injector.get(Materials_OperationService);
    this.Carriers = this.injector.get(Carriers_OperationService);
    this.Locations = this.injector.get(Locations_OperationService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_OperationService);
    this.Invoices = this.injector.get(Invoices_OperationService);
    this.Notifications = this.injector.get(Notifications_OperationService);
    this.SalesOrders = this.injector.get(SalesOrders_OperationService);
    this.FootprintManager = this.injector.get(FootprintManager_OperationService);
  }

    public Document360: Document360_OperationService;
    public Usersnap: Usersnap_OperationService;
    public Utilities: Utilities_OperationService;
    public Addresses: Addresses_OperationService;
    public Discussions: Discussions_OperationService;
    public DockAppointments: DockAppointments_OperationService;
    public Owners: Owners_OperationService;
    public Instructions: Instructions_OperationService;
    public Materials: Materials_OperationService;
    public Carriers: Carriers_OperationService;
    public Locations: Locations_OperationService;
    public PurchaseOrders: PurchaseOrders_OperationService;
    public Invoices: Invoices_OperationService;
    public Notifications: Notifications_OperationService;
    public SalesOrders: SalesOrders_OperationService;
    public FootprintManager: FootprintManager_OperationService;
  public app: app_OperationService = this;


  private isAuthorized(operationName: string): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/app/operations/${operationName}/isauthorized`, null);
  }
}
